var map = {
	"./icons/arrow_left.svg": 3556,
	"./icons/arrow_right.svg": 219,
	"./icons/arrows_up_down.svg": 9272,
	"./icons/calendar.svg": 3060,
	"./icons/caret_down.svg": 9221,
	"./icons/caret_left.svg": 5166,
	"./icons/caret_right.svg": 5677,
	"./icons/check.svg": 1691,
	"./icons/edit_dots.svg": 7304,
	"./icons/error.svg": 8029,
	"./icons/filetype_folder.svg": 3766,
	"./icons/filetype_generated.svg": 2097,
	"./icons/filetype_group.svg": 7583,
	"./icons/filetype_set.svg": 6606,
	"./icons/filetype_single_image.svg": 2004,
	"./icons/filetype_single_pdf.svg": 8005,
	"./icons/filetype_single_video.svg": 4126,
	"./icons/home.svg": 532,
	"./icons/hourglass.svg": 9029,
	"./icons/info.svg": 7865,
	"./icons/list.svg": 3909,
	"./icons/logout.svg": 8619,
	"./icons/menu_apps.svg": 3231,
	"./icons/menu_bibliothek.svg": 5122,
	"./icons/menu_generator.svg": 2598,
	"./icons/menu_playlists.svg": 3136,
	"./icons/menu_screens.svg": 634,
	"./icons/menu_settings.svg": 4384,
	"./icons/menu_users.svg": 841,
	"./icons/selectTriangle.svg": 7521,
	"./icons/sorting.svg": 1803,
	"./icons/success.svg": 2110,
	"./icons/tiles.svg": 5592,
	"./icons/times.svg": 5477,
	"./icons/trash.svg": 297,
	"./icons/warning.svg": 9251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7665;